import './App.css';
import {Grid} from "@mui/material";
import Pagina from "./Pagina/Pagina";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/600.css';
import '@fontsource/raleway/400.css';
import '@fontsource/raleway/500.css';
import '@fontsource/raleway/600.css';
import '@fontsource/raleway/700.css';
import '@fontsource/raleway/800.css';
import {useObtenerDataActualizada} from "./Modulo_Optimizacion_Data/Hooks/useObtenerDataActualizada";
import {createContext, useEffect} from "react";
import {obtenerFechaAct} from "./Servicios/BD/Actualizadores/obtenerFechaAct";
import {where} from "firebase/firestore";

export const contexApp = createContext()

function App() {
    const {data: habitaciones, actualizarDataLocal: actHabitaciones} = useObtenerDataActualizada({
        clave: 'habitaciones',
    })

    const valoresProvider = {
        habitaciones
    }

    const {Provider} = contexApp;


    useEffect(() => {

        //se verifica si esta o no actualizado
        let w = [where('estado', '==', 'Libre')]
        obtenerFechaAct('habitaciones').then((dox) => {
            actHabitaciones({fecha: dox, wheres: w}).then()
        })


    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>



            <Provider value={valoresProvider}>
                <Pagina/>
            </Provider>

        </Grid>
    );
}

export default App;
